import pathToRegexp from 'path-to-regexp';

export function generateChildRoutes(sharedPath, routes) {
  const patchedRoutes = Object.keys(routes).reduce((accRoutes, routeKey) => {
    const route = routes[routeKey];
    return {
      ...accRoutes,
      [routeKey]: route.root
        ? generateChildRoutes(sharedPath, route)
        : `${sharedPath}${routes[routeKey]}`,
    };
  }, {});
  return {
    ...patchedRoutes,
    root: routes.root ? `${sharedPath}${routes.root}` : sharedPath,
  };
}

const routeCompileCache = {};

function routeCompile(route, params) {
  if (!routeCompileCache[route]) routeCompileCache[route] = pathToRegexp.compile(route);
  return routeCompileCache[route](params);
}

export function generateToPath(routes) {
  return Object.keys(routes).reduce((accRouteToPath, routeKey) => {
    const route = routes[routeKey];
    return {
      ...accRouteToPath,
      [routeKey]: route.root
        ? generateToPath(route)
        : params => routeCompile(route, params),
    };
  }, {});
}

const routes = {
  download: '/download',
  home: '/',
  privacyPolicy: '/privacy-policy',
  support: '/support',
  termsOfService: '/terms-of-service',
  thankYou: '/thank-you',
  answerRequest: generateChildRoutes('/answer', {
    contactAdded: '/contact-added',
    requiresAuthentication: '/requires-authentication',
  }),
};

export const toPath = generateToPath(routes);

export default routes;
